import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import Slider from 'react-slick';

const Testimonials = () => {

    const testimonialslider = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 3000,
        arrows: false,
    };

    return (
        <>
            {/* Testimonials */}
            <section className="testimonial-section-five">
                <ImageWithBasePath
                    src="./assets/img/shapes/quote.png"
                    className="d-none d-lg-flex testimonials-quote"
                    alt="Img"
                />
                <div className="container">
                    <div className="header-five-title text-center" data-aos="fade-down">
                        <h2 className="text-light">Testimonials</h2>
                        <p className="text-white">
                            We are very happy because we have happy customers{" "}
                        </p>
                    </div>
                    <div className="testimonial-slider-five">
                        <Slider {...testimonialslider}>
                            <div className="testimonial-carousel">
                                <div className="testimonial-item-six">
                                    <div className="testimonial-content-five">
                                        <div className="testimonial-text">
                                            <h5 className="mb-3">
                                                When Everything Finally Fell into Place
                                            </h5>
                                            <p className="mb-3">
                                                "I spent months trying to apply to schools with no luck. Then I found this platform—and it felt like a blessing from above. Everything just clicked into place."
                                            </p>
                                        </div>
                                        <div className="testimonial-users-group d-flex align-items-center justify-content-between">
                                            <div className="testimonial-users">
                                                <h5 className="mb-1">Hawkins</h5>
                                            </div>
                                            <div className="testimonial-ratings-five d-inline-flex align-items-center">
                                                <div className="rating">
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="testimonial-image">
                                        <ImageWithBasePath
                                            src="assets/img/testimonial/testimonials-1.png"
                                            alt="Img"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="testimonial-carousel">
                                <div className="testimonial-item-six">
                                    <div className="testimonial-content-five">
                                        <div className="testimonial-text">
                                            <p className="mb-3">
                                                "This platform made my application process so much easier and faster. The guidance and resources provided helped me find the perfect program without the usual hassle. It truly feels like the support I was missing. I highly recommend it to any student aiming to study abroad!"
                                            </p>
                                        </div>
                                        <div className="testimonial-users-group d-flex align-items-center justify-content-between">
                                            <div className="testimonial-users">
                                                <h5 className="mb-1">Arabelle A.</h5>
                                            </div>
                                            <div className="testimonial-ratings-five d-inline-flex align-items-center">
                                                <div className="rating">
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="testimonial-image">
                                        <ImageWithBasePath
                                            src="assets/img/testimonial/testimonial-02.png"
                                            alt="Img"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="testimonial-carousel">
                                <div className="testimonial-item-six">
                                    <div className="testimonial-content-five">
                                        <div className="testimonial-text">
                                            <p className="mb-3">
                                                "I really appreciate the support I received. This solution perfectly matched my needs and saved me a lot of time and energy. The expertise provided was exactly what was missing. I'm confident you won't be disappointed."
                                            </p>
                                        </div>
                                        <div className="testimonial-users-group d-flex align-items-center justify-content-between">
                                            <div className="testimonial-users">
                                                <h5 className="mb-1">Nikolas Brooten</h5>
                                            </div>
                                            <div className="testimonial-ratings-five d-inline-flex align-items-center">
                                                <div className="rating">
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                    <i className="fas fa-star filled" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="testimonial-image">
                                        <ImageWithBasePath
                                            src="assets/img/testimonial/testimonial-03.png"
                                            alt="Img"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
            {/* /Testimonials */}
        </>

    )
}

export default Testimonials
